<template>
	<td :class="className">
		<button type="button" class="btn_select" @click="onSelect">
			<span class="inner_day">{{date ? date : ''}}
				<span class="month_schedule ir_pm">
					<span class="sr_only">스케줄</span>
					<span v-for="schedule in slicedSchedules" class="ir_pm detail_schedule"
						:style="style(schedule.category.color)">{{schedule.category.name}}</span>
					<span v-if="schedulesTooMany" class="ico_cafe ico_more">더보기</span>
				</span>
			</span>
		</button>
	</td>
</template>

<script>
	import { mapState, mapMutations } from 'vuex';
	import { format, startOfDay } from 'date-fns';

	export default {
		props: ['year', 'month', 'date', 'schedules'],
		computed: {
			...mapState({
				selected: 'date',
			}),

			dateObj() {
				return new Date(this.year, this.month, this.date);
			},
			isToday() {
				return startOfDay(new Date()).getTime() === this.dateObj.getTime();
			},
			isSelected() {
				return this.selected && this.selected.getTime() === this.dateObj.getTime();
			},

			_schedules() {
				const dateText = format(this.dateObj, 'yyyy-MM-dd');
				return dateText in this.schedules
					? this.schedules[dateText]
					: [];
			},
			slicedSchedules() {
				return this._schedules.slice(0, this.schedulesTooMany ? 2 : 3);
			},
			schedulesTooMany() {
				return this._schedules.length > 3;
			},

			className() {
				return {
					today: this.isToday && !this.isSelected,
					select_day: this.isSelected,
				};
			},
		},
		methods: {
			...mapMutations(['changeDate']),
			onSelect() {
				if (this.date) {
					this.changeDate(this.dateObj);
				}
			},

			style(color) {
				return {
					backgroundColor: color,
				};
			},
		}
	}
</script>
